module.exports = __webpack_public_path__ + "img/cuowu_0.3491adc1.svg";